export var WebsiteEvents = {
  // https://github.com/miroapp-dev/event-schemas/blob/main/events/website_scrolled/index.md
  SCROLL: 'website_scrolled',
  // https://github.com/miroapp-dev/event-schemas/blob/main/events/website_tab_exited/index.md
  TAB_EXITED: 'website_tab_exited',
  // https://github.com/miroapp-dev/event-schemas/blob/main/events/website_heartbeat_sent/index.md
  HEARTBEAT: 'website_heartbeat_sent',
  // https://github.com/miroapp-dev/event-schemas/blob/main/events/button_clicked/index.md
  USER_CLICK: 'button_clicked'
};